import React from 'react';
import { Helmet } from 'react-helmet-async';
import ContactForm from '../Components/ContactForm/ContactForm'
import Breadcrumb from '../Components/Breadcrumb';

function Contact() {
    const breadcrumbLinks = [
        { label: 'Home', url: '/' },
        { label: 'Contact' },
    ];

    return (
        <>
            <Helmet>
                <title>Contact – Fusion Hub</title>
                <meta name="description" content="Get in touch with Fusion Hub for expert engineering, IT, and business solutions. We're here to help your business grow." />
            </Helmet>
            <Breadcrumb pageTitle="Contact" breadcrumbLinks={breadcrumbLinks} />

            <div className="contact-form-area pd-top-190">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-xl-6 col-lg-8">
                            <div className="section-title text-center w-100 pb-5">
                                <h2 className="title">Get in <span>Touch</span></h2>
                                <p className='text-center'>We are always available to help</p>
                            </div>
                        </div>
                    </div>
                    <ContactForm />
                </div>
            </div>

            <div className="map-area pd-top-120">
                <div className="container">
                    <div className="map-area-wrap">
                        <div className="row no-gutters">
                            <div className="col-lg-6">
                                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d52800713.90268146!2d-161.4380609309403!3d36.12517020060036!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x54eab584e432360b%3A0x1c3bb99243deb742!2sUnited%20States!5e0!3m2!1sen!2s!4v1751903995557!5m2!1sen!2s" width="600" height="450" className='border-0' allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>                            </div>
                            <div className="col-lg-4 desktop-center-item">
                                <div>
                                    <div className="contact-info">
                                        <h4 className="title">Contact info:</h4>
                                        <p><span>Address:</span> 1611 Remington Road Prosper, Texas 75078 United States</p>
                                        <p><span>Phone:</span> +1 (469) 983-4445</p>
                                        <p><span>E-mail:</span> sales@fusion-hub.com</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}


export default Contact;